module.exports = __webpack_public_path__ + "assets1752042029796/img/lan2.eddb60b0.png";